"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _winDoc = require("win-doc");
var _reshowConstant = require("reshow-constant");
//@ts-check

var g = (0, _winDoc.hasWin)() ? (0, _winDoc.win)() : globalThis;

/**
 * Assign value from g.reactStylesStore for sync npm link case
 */
var stylesStore = g.reactStylesStore ? g.reactStylesStore : {
  registry: (0, _reshowConstant.NEW_OBJ)(),
  newStyles: [],
  counter: 0
};
g.reactStylesStore = stylesStore;
var _default = exports["default"] = stylesStore;
module.exports = exports.default;